import { render, staticRenderFns } from "./admin-request-form.vue?vue&type=template&id=4853c97a&scoped=true&"
import script from "./admin-request-form.vue?vue&type=script&lang=js&"
export * from "./admin-request-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4853c97a",
  null
  
)

export default component.exports